import { getDataMapper, mapField, getObjectId } from "@/shared";

export const mapRentKitToServer = getDataMapper(
    {
        kit_id: mapField("kit", getObjectId),
        price_id: mapField("price", getObjectId),
    },
    { shouldAvoidUndefined: true }
);
